export default {
  methods: {
    getStatusColour(status) {
      switch (status) {
        case 'InProgress': return 'orange';
        case 'Completed': return 'green';
        default: return 'grey';
      }
    },
  },
};
